import { useCallback, useMemo, useState, type ReactNode } from 'react';
import { EMPTY_HEADER, HeaderContext, type HeaderContent } from './headerContext';

interface Entry {
  id: string;
  content: HeaderContent;
}

export function HeaderContextProvider({ children }: { children: ReactNode }) {
  const [entries, setEntries] = useState<Entry[]>([]);
  const setEntry = useCallback((id: string, content: HeaderContent) => {
    setEntries((prev) =>
      prev.some((entry) => entry.id === id)
        ? prev.map((entry) => (entry.id === id ? { id, content } : entry))
        : [...prev, { id, content }],
    );
  }, []);
  const removeEntry = useCallback((id: string) => {
    setEntries((prev) => prev.filter((entry) => entry.id !== id));
  }, []);
  const content = entries.at(-1)?.content ?? EMPTY_HEADER;
  const value = useMemo(
    () => ({ content, setEntry, removeEntry }),
    [content, setEntry, removeEntry],
  );
  return <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>;
}
